import EcgEdit from './edit/EcgEdit';
import BpmEdit from './edit/BpmEdit';
import {
  BpmWidget,
  ChristmasWidget,
  DeadByDaylightWidget,
  DeadSpaceWidget,
  SpeedTestWidget,
  GlowyWidget,
  GaugeWidget,
  BeatSaberWidget,
  DiabloWidget,
  ResidentEvilWidget,
  UnicornWidget,
  AnimeBarWidget,
  AlanWakeWidget,
  JumpScareCounterWidget as JumpScareCounterWidgetV2,
  AloneInTheDarkWidget,
  FalloutWidget,
  StarWarsWidget,
  ValorantWidget as ValorantWidgetV2,
  EldenRingWidget,
  SilentHill2Widget,
  Stalker2Widget,
  MetaPulsatingWidget,
  PulsatingCircleWidget,
  EcgHeartWidget,
  MaxWidget,
  BpmPercentageWidget,
  MonsterHunterWildsWidget,
} from '@pulsoid-private/widgets-lib';
import {PixelHeartWidget} from './widgets/PixelHeartWidget';
import {CaloriesWidget} from './widgets/CaloriesWidget';
import {RealHeartWidget} from './widgets/RealHeartWidget';
import {PictureWidget} from './widgets/PictureWidget';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faVolumeUp} from '@fortawesome/free-solid-svg-icons';
import {HeartAnimationWidget} from './widgets/HeartAnimationWidget';
import {RealTimeGraphWidget} from './widgets/RealTimeGraphWidget';
import {
  MeatBeatsSaberV2Widget,
  MeatDeathloopWidget,
  MetaBeatsSaberWidget,
  MetaBpmAdvancedWidget,
  MetaBpmBasicWidget,
  MetaBpmPercentageWidget,
  MetaBpmWidget,
  MetaCaloriesWidget,
  MetaCyberpunkHeartWidget,
  MetaDeadByDaylightWidget,
  MetaDeadSpaceWidget,
  MetaEcgWidget,
  MetaFitnessZoneWidget,
  MetaGaugeWidget,
  MetaGeometryDashWidget,
  MetaGlowyWidget,
  MetaGraphV2,
  MetaGraphWidget,
  MetaHalloweenMoon,
  MetaHeartAnimationWidget,
  MetaJumpScareCounterWidget,
  MetaMaxWidget,
  MetaMinecraftWidget,
  MetaPictureWidget,
  MetaPixelWidget,
  MetaPulsoidMedicalWidget,
  MetaPulsoidStromnoWidget,
  MetaRealHeartWidget,
  MetaReferralWidget,
  MetaResidentEvilWidget,
  MetaSoundWidget,
  MetaSoundWidgetV2,
  MetaTextWidget,
  MetaValorantWidget,
  MetaVideoWidget,
  MetaWindowsNtWidget,
  MetaChristmasWidget,
  MetaSpeedtestWidget,
  MetaPrideBpmBasicWidget,
  MetaDiabloWidget,
  MetaUnicornWidget,
  MetaAnimeBarWidget,
  MetaAlanWakeWidget,
  MetaAloneInTheDarkWidget,
  MetaFalloutWidget,
  MetaStarWarsWidget,
  MetaValorantWidgetV2,
  MetaEldenRingWidget,
  MetaSilentHill2Widget,
  AllMetaIds,
  MetaStromnoWdiget,
  MetaPredictionWidget,
  MetaStalkerWidget,
  MetaMonsterHunterWidget,
} from '@pulsoid-private/widgets-lib';
import {ValorantWidget} from './widgets/ValorantWidget';
import {TextWidget} from './widgets/TextWidget';
import {VideoWidget} from './widgets/VideoWidget';
import {FitnessZoneWidget} from './widgets/FitnessZoneWidget';
import {PulsoidMedicalWidget} from './widgets/PulsoidMedicalWidget';
import {CyberpunkHeartWidget} from './widgets/CyberpunkHeartWidget';
import {WindowsNT} from './widgets/WindowsNT';
import {BeatsSaberWidget} from './widgets/BeatsSaberWidget';
import {PulsoidStromnoWidget} from './widgets/PulsoidStromnoWidget';
import {GeometryDashWidget} from './widgets/GeometryDashWidget';
import {DeathLoopWidget} from './widgets/DeathLoopWidget';
import {HalloweenMoonWidget} from './widgets/HalloweenMoonWidget';
import {JumpScareCounterWidget} from './widgets/JumpScareCounterWidget';
import {RealTimeGraphWidgetV2} from './widgets/RealTimeGraphWidgetV2';
import {MinecraftWidget} from './widgets/MinecraftWidget';
import {ReferralWidget} from './widgets/ReferralWidget';
import {TextWidgetEdit} from './edit/TextWidgetEdit';
import {VideoEdit} from './edit/VideoEdit';
import {FitnessZoneEdit} from './edit/FitnessZoneEdit';
import BpmPercentageEdit from './edit/BpmPercentageEdit';
import {GaugeWidgetEdit} from './edit/GaugeWidgetEdit';
import BpmBasicEdit from './edit/BpmBasicEdit';
import GeometryDashEdit from './edit/GeometryDashbEdit';
import BeatSabersV2Edit from './edit/BeatSabersV2Edit';
import {SoundWidgetV2Edit} from './edit/SoundWidgetV2Edit';
import {PremiumWrapperOverlay} from '../PremiumWrapperOverlay';
import RealTimeGraphWidgetV2Edit from './edit/RealTimeGraphWidgetV2Edit';
import GlowyWidgetEdit from './edit/GlowyWidgetEdit';
import MinecraftWidgetEdit from './edit/MinecraftWidgetEdit';
import ReferralEdit from './edit/ReferralEdit';
import {ResidentEvilEdit} from './edit/ResidentEvilEdit';
import {DeadByDaylightEdit} from './edit/DeadByDaylightEdit';
import {DeadSpaceEdit} from './edit/DeadSpaceEdit';
import {ChristmasWidgetEdit} from './edit/ChristmasWidgetEdit';
import {BpmAdvancedEdit} from './edit/BpmAdvancedEdit/BpmAdvancedEdit';
import {SpeedTestEdit} from './edit/SpeedTestEdit';
import {PrideBpmBasicEdit} from './edit/PrideBpmBasicEdit';
import {DiabloEdit} from './edit/DiabloEdit';
import {UnicornEdit} from './edit/UnicornEdit';
import {AnimeBarWidgetEdit} from './edit/AnimeBarWidgetEdit';
import {JumpScareCounterEditNew} from './edit/JumpScareCounterEditNew';
import {AlanWakeWidgetEdit} from './edit/AlanWakeWidgetEdit';
import {FalloutWidgetEdit} from './edit/FalloutWidgetEdit';
import {ValorantWidgetV2Edit} from './edit/ValorantWidgetV2Edit';
import {EldenRingWidgetEdit} from './edit/EldenRingWidgetEdit';
import PictureBpmEdit from './edit/PictureBpmEdit';
import SoundBpmEdit from './edit/SoundBpmEdit';
import HeartAnimationEdit from './edit/HeartAnimationEdit';
import RealTimeGraphWidgetEdit from './edit/RealTimeGraphWidgetEdit';
import MaxEdit from './edit/MaxEdit';
import CaloriesEdit from './edit/CaloriesEdit';
import {PredictionWidgetEdit} from './edit/PredictionWidgetEdit';
import {StalkerWidgetEdit} from './edit/StalkerWidgetEdit';
import {PulsatingCircleWidgetEdit} from './edit/PulsatingCircleWidgetEdit';
import {MonsterHunterWidgetEdit} from './edit/MonsterHunterWidgetEdit';
import ReactPlayer from 'react-player';

const LIB_MIGRATED_VERSION = {
  version: 'LibMigrated',
};

export const WidgetConfiguration = {
  [MetaEcgWidget]: {
    edit: (props) => <EcgEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <EcgHeartWidget
          pulse={heartRate}
          configuration={{...configuration, ...LIB_MIGRATED_VERSION}}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaBpmWidget]: {
    edit: (props) => <BpmEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <BpmWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaPixelWidget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <PixelHeartWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaCaloriesWidget]: {
    edit: (props) => <CaloriesEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <CaloriesWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaRealHeartWidget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <RealHeartWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaPictureWidget]: {
    edit: (props) => <PictureBpmEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <PictureWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaSoundWidget]: {
    edit: (props) => <SoundBpmEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <div>
          <FontAwesomeIcon icon={faVolumeUp} size={'4x'} />
        </div>
      );
    },
  },
  [MetaHeartAnimationWidget]: {
    edit: (props) => <HeartAnimationEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <div>
          <HeartAnimationWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaGraphWidget]: {
    edit: (props) => <RealTimeGraphWidgetEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <div>
          <RealTimeGraphWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaMaxWidget]: {
    edit: (props) => <MaxEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <MaxWidget
          pulse={heartRate}
          configuration={{...configuration, ...LIB_MIGRATED_VERSION}}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaTextWidget]: {
    edit: (props) => <TextWidgetEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <TextWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaVideoWidget]: {
    edit: (props) => <VideoEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <VideoWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaFitnessZoneWidget]: {
    edit: (props) => <FitnessZoneEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <FitnessZoneWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaValorantWidget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <div>
          <ValorantWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaValorantWidgetV2]: {
    edit: (props) => <ValorantWidgetV2Edit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <ValorantWidgetV2
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaEldenRingWidget]: {
    edit: (props) => <EldenRingWidgetEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <EldenRingWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaPulsoidMedicalWidget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <PulsoidMedicalWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaCyberpunkHeartWidget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CyberpunkHeartWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaBeatsSaberWidget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <BeatsSaberWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaWindowsNtWidget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <WindowsNT
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaPulsoidStromnoWidget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <PulsoidStromnoWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaBpmPercentageWidget]: {
    edit: (props) => <BpmPercentageEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <BpmPercentageWidget
            configuration={{...configuration, ...LIB_MIGRATED_VERSION}}
            pulse={heartRate}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaGaugeWidget]: {
    edit: (props) => <GaugeWidgetEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <GaugeWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaBpmBasicWidget]: {
    edit: (props) => <BpmBasicEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <BpmWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaBpmAdvancedWidget]: {
    edit: (props) => <BpmAdvancedEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <BpmWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaGeometryDashWidget]: {
    edit: (props) => <GeometryDashEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <GeometryDashWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MeatBeatsSaberV2Widget]: {
    edit: (props) => <BeatSabersV2Edit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <BeatSaberWidget
          pulse={heartRate}
          configuration={{
            ...configuration,
            withHeart: configuration.heartEnabled,
          }}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaSoundWidgetV2]: {
    edit: (props) => (
      <PremiumWrapperOverlay disabled={!props.premiumUpdate}>
        <SoundWidgetV2Edit {...props} />
      </PremiumWrapperOverlay>
    ),
    widget: (configuration, heartRate, key) => {
      return (
        <div>
          <FontAwesomeIcon icon={faVolumeUp} size={'4x'} />
        </div>
      );
    },
  },
  [MetaJumpScareCounterWidget]: {
    edit: (props) => <JumpScareCounterEditNew {...props} />,
    widget: (configuration, heartRate, key) => {
      if (configuration?.version === 2) {
        return (
          <JumpScareCounterWidgetV2
            pulse={heartRate}
            configuration={configuration}
            key={key}
          />
        );
      } else {
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <JumpScareCounterWidget
              pulse={heartRate}
              configuration={configuration}
              fromLaunch={false}
              key={key}
            />
          </div>
        );
      }
    },
  },
  [MeatDeathloopWidget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <DeathLoopWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaHalloweenMoon]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <HalloweenMoonWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaGraphV2]: {
    edit: (props) => <RealTimeGraphWidgetV2Edit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <div>
          <RealTimeGraphWidgetV2
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaGlowyWidget]: {
    edit: (props) => <GlowyWidgetEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <GlowyWidget
          pulse={heartRate}
          configuration={{
            ...configuration,
            textColor: configuration.bpmColor,
          }}
          key={key}
        />
      );
    },
  },
  [MetaMinecraftWidget]: {
    edit: (props) => <MinecraftWidgetEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MinecraftWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaReferralWidget]: {
    edit: (props) => <ReferralEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <div>
          <ReferralWidget
            pulse={heartRate}
            configuration={configuration}
            fromLaunch={false}
            key={key}
          />
        </div>
      );
    },
  },
  [MetaResidentEvilWidget]: {
    edit: (props) => <ResidentEvilEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <ResidentEvilWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaDeadByDaylightWidget]: {
    edit: (props) => <DeadByDaylightEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <DeadByDaylightWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaDeadSpaceWidget]: {
    edit: (props) => <DeadSpaceEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <DeadSpaceWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaChristmasWidget]: {
    edit: (props) => <ChristmasWidgetEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <ChristmasWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaSpeedtestWidget]: {
    edit: (props) => <SpeedTestEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <SpeedTestWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaPrideBpmBasicWidget]: {
    edit: (props) => <PrideBpmBasicEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <BpmWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaDiabloWidget]: {
    edit: (props) => <DiabloEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <DiabloWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaUnicornWidget]: {
    edit: (props) => <UnicornEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <UnicornWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaAnimeBarWidget]: {
    edit: (props) => <AnimeBarWidgetEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <AnimeBarWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaAlanWakeWidget]: {
    edit: (props) => <AlanWakeWidgetEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <AlanWakeWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaAloneInTheDarkWidget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <AloneInTheDarkWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaFalloutWidget]: {
    edit: (props) => <FalloutWidgetEdit {...props} />,
    widget: (configuration, heartRate, key) => {
      return (
        <FalloutWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaSilentHill2Widget]: {
    edit: (props) => <div />,
    widget: (configuration, heartRate, key) => {
      return (
        <SilentHill2Widget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaStarWarsWidget]: {
    edit: (props) => (
      <div>
        This is a beta version of the widget featuring an upward scrolling text
        effect. If you encounter any bugs, please send a report accompanied by a
        screen recording or clip to{' '}
        <a href="mailto:support@pulsoid.net">support@pulsoid.net</a>
      </div>
    ),
    widget: (configuration, heartRate, key) => {
      return (
        <StarWarsWidget
          pulse={heartRate}
          configuration={configuration}
          fromLaunch={false}
          key={key}
        />
      );
    },
  },
  [MetaStromnoWdiget]: {
    edit: (props) => <></>,
    widget: (configuration, heartRate, key) => <></>,
  },
  [MetaPredictionWidget]: {
    edit: (props) => <PredictionWidgetEdit {...props}></PredictionWidgetEdit>,
    widget: (configuration, heartRate, key) => (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <ReactPlayer
          height={'7em'}
          width={'7em'}
          loop={true}
          muted={true}
          playing={true}
          controls={false}
          url={
            'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/prediction-widget/prediction-widget-demo_cropped_2.mp4'
          }
        />
      </div>
    ),
  },
  [MetaStalkerWidget]: {
    edit: (props) => <StalkerWidgetEdit {...props}></StalkerWidgetEdit>,
    widget: (configuration, heartRate, key) => (
      <Stalker2Widget
        style={{
          position: 'relative',
        }}
        pulse={heartRate}
        configuration={configuration}
        fromLaunch={false}
        key={key}
      ></Stalker2Widget>
    ),
  },
  [MetaPulsatingWidget]: {
    edit: (props) => <PulsatingCircleWidgetEdit></PulsatingCircleWidgetEdit>,
    widget: (configuration, heartRate, key) => (
      <PulsatingCircleWidget
        pulse={heartRate}
        configuration={configuration}
        fromLaunch={false}
        key={key}
      ></PulsatingCircleWidget>
    ),
  },
  [MetaMonsterHunterWidget]: {
    edit: (props) => <MonsterHunterWidgetEdit props={props} />,
    widget: (configuration, heartRate, key) => (
      <MonsterHunterWildsWidget
        pulse={heartRate}
        configuration={configuration}
        fromLaunch={false}
        key={key}
      ></MonsterHunterWildsWidget>
    ),
  },
};
